import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import { APEXMemberSearchForm } from "webapp/components/Partner/APEX/APEXMemberSearchForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

export default function APEXMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [last8Vin, setLast8Vin] = useState(
    props.context.state.MemberLookup.last8Vin || props.context.state.last8Vin || "",
  );

  const [searchType, setSearchType] = useState(
    props.context.state.MemberLookup.searchType || props.context.state.searchType || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.last8Vin === "string") {
        setLast8Vin(data.last8Vin);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
        MemberLookup: {
          last8Vin: data.last8Vin,
          searchType: data.searchType,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("FIMC.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("BWC.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <APEXMemberSearchForm
        last8Vin={last8Vin}
        searchType={searchType}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
      />
    </div>
  );
}
